_ = require('underscore')

internalCallback = null

window.onFusionTablesLoaded = (data) ->
  if _.isFunction(internalCallback)
    internalCallback(data)

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  components:

    'map-canvas': require('./components/map')

  props:
    active_country_codes: { default: null }
    country_links:        { default: null }
    zoom_state:           { default: 'world' }
    center_lat:           { default: null }
    center_lng:           { default: null }
    interactive:          { default: false }

  data: ->
    maps:         null
    map:          null
    modalVisible: false

  computed:

    windowWidth: ->
      @.$store.state.window.width

    activeCountryCodesArray: ->
      @active_country_codes.split(',')

    countryLinksData: ->
      @_countryLinksData or= _.reduce @country_links.split(';;;'), (memo, line) ->
        line = line.split(':::')
        memo[line[0]] = {
          url:  line[1]
          name: line[2]
        }
        memo
      , {}

    mapZoom: ->
      z = if @zoom_state == 'world' then 5 else 3
      z = z + 1 if @windowWidth <= 1000
      z

    defaultCenterLatLng: ->
      return { lat: 0.0, lng: 0.0 } unless @center_lat? && @center_lng?

      { lat: parseFloat(@center_lat), lng: parseFloat(@center_lng) }

    isInteractive: ->
      @interactive != false && @interactive != 'false'

  methods:

    onMapCountryClicked: (data) ->
      return unless data.active == true

      link = @countryLinksData[data.iso_3166_2]
      return unless _.isObject(link) && link.url?

      # if confirm(@.$t('countries_map.open_country_message', { country: link.name }))
      window.location.href = link.url


// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/index.coffee